<template>
  <div v-if="changeUrl.length > 0" :class="$style.container">
    <Modal :is-modal-open="isModalOpenRef" @close-modal="handleClose">
      <div :class="$style.content">
        <div :class="$style.title">
          {{ config.title }}
        </div>
        <p>{{ text }}</p>
        <div class="columns is-mobile">
          <div class="column">
            <Button colour="blue" :href="changeUrl" is-link :text="config.changeButtonText" />
          </div>
          <div :class="[$style.buttonRight, 'column']">
            <Button colour="white" is-close :text="config.stayButtonText" @close="handleClose" />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import * as Storage from '../../shared/Storage';
import { geoIPUrl } from '../../shared/globals';
import Button from '../Button/Button.vue';
import Modal from '../Modal/Modal.vue';
import safeFetch from '../../utils/safeFetch';

const props = defineProps({
  config: {
    type: Object,
    default: () => {},
  },
});

const GEOIP_COOKIE = 'hideGeoIpOverlayFor';

const countriesJSONRef = ref(null);
const isModalOpenRef = ref(false);
const cookieName = ref('');
const text = ref('');
const changeUrl = ref('');
const changeName = ref('');
const currentCountry = ref('');
const websiteCountryRef = ref('');

const initGeoIP = () => {
  safeFetch(props.config.countriesJSON)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => ((countriesJSONRef.value = data.countries), getGeoIp()))
    .catch((error) => console.error(error));
};

const getGeoIp = () => {
  safeFetch(window.geoIPUrl || geoIPUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      checkGeoIp(data[0]);
    })
    .catch((error) => {
      console.error(error);
    });
};

const checkGeoIp = (data) => {
  currentCountry.value = data.country_code;

  if (
    countriesJSONRef.value &&
    currentCountry.value &&
    currentCountry.value !== 'unknown' &&
    currentCountry.value !== websiteCountryRef.value &&
    currentCountry.value !== cookieName.value &&
    websiteCountryRef.value !== cookieName.value
  ) {
    Object.keys(countriesJSONRef.value).forEach((countryKey) => {
      if (countryKey === currentCountry.value) {
        const { url, name } = countriesJSONRef.value[countryKey];

        if (!url && props.config.corporateWebsiteUrl && !props.config.isCorporateWebsite) {
          changeUrl.value =
            window?.instance === 'shop'
              ? props.config.corporateShopUrl
              : props.config.corporateWebsiteUrl;
          text.value = props.config.corporateText
            ? props.config.corporateText
            : props.config.text.replace(/{{countryName}}/gi, changeName.value);
        } else {
          changeUrl.value = url;
          changeName.value = name;
          text.value = props.config.text.replace(/{{countryName}}/gi, changeName.value);
        }
      }
    });

    if (
      !Object.hasOwn(countriesJSONRef.value, currentCountry.value) &&
      !!props.config.corporateWebsiteUrl &&
      !props.config.isCorporateWebsite
    ) {
      changeUrl.value =
        window?.instance === 'shop'
          ? props.config.corporateShopUrl
          : props.config.corporateWebsiteUrl;
      text.value = props.config.corporateText
        ? props.config.corporateText
        : props.config.text.replace(/{{countryName}}/gi, changeName.value);
    }

    if (changeUrl.value) {
      try {
        const targetUrlObj = new URL(changeUrl.value);
        const targetPath = targetUrlObj.pathname;
        const currentPath = window.location.pathname;

        if (targetPath !== '/' && currentPath.includes(targetPath)) {
          return;
        }
      } catch (error) {
        console.error(error);
        if (window.location.href.indexOf(changeUrl.value) > -1) {
          return;
        }
      }
    }

    setTimeout(() => {
      isModalOpenRef.value = true;
    }, 600);
  }
};

const handleClose = () => {
  Storage.setSessionStorage(GEOIP_COOKIE, websiteCountryRef.value);
  isModalOpenRef.value = false;
};

onBeforeMount(() => {
  websiteCountryRef.value = props.config.websiteCountry;
  cookieName.value = Storage.getSessionStorage(GEOIP_COOKIE);
  const queries = window.location.search.substring(1).split('&');
  if (queries) {
    for (const query of queries) {
      if (query.includes('dssheet')) {
        return;
      }
    }
  }

  if (props.config.countriesJSON) {
    try {
      initGeoIP();
    } catch (error) {
      console.error(error);
    }
  }
});
</script>

<style module lang="scss">
@forward './GeoIPOverlay.scss';
</style>
